var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-tip-box"},[_c('div',{staticClass:"color-box",style:({backgroundColor:_vm.color})}),_c('div',{style:({color:_vm.color})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }